export const SENIOR_MANAGER = 'ROLE_SENIOR_MANAGER';
export const MANAGER = 'ROLE_MANAGER';
export const ADMIN = 'ROLE_ADMIN';
export const MODERATOR = 'ROLE_MODERATOR'

export const ADMIN_MODERATOR = [ADMIN, MODERATOR];
export const MANAGERS = [SENIOR_MANAGER, MANAGER];
